<!-- Vocabulary Word Separator -->
<ng-template #vocabulary_word_separator_template let-char="char">
  <div class="followMeBar">
    <span class="alpha">{{char}}</span>
  </div>
</ng-template>

<!-- Vocabulary Word -->
<ng-template #vocabulary_word_template let-vocabularyWord="vocabularyWord">
  <dl>
    <dt>{{vocabularyWord.key}}</dt>
    <dd>{{vocabularyWord.value}}</dd>
  </dl>
</ng-template>

<!-- Vocabulary Group -->
<ng-template #vocabulary_group_template let-vocabularyGroup="vocabularyGroup" let-vocabularyWords="vocabularyWords" let-showCurrentChar="showCurrentChar">
  @if (vocabularyGroup && vocabularyWords) {
    @if (vocabularyWords.length > 0) {
      <div class="pl-0">
        @if (vocabularyGroup.name) {
          <div class="followMeBar">
            <span class="alpha" translate="{{ vocabularyGroup.name.length > 1 ? vocabularyGroup.name : vocabularyGroup.name.toUpperCase() }}"></span>
          </div>
        }
        @for (vocabularyWord of vocabularyWords; track vocabularyWord) {
          @if (showCurrentChar && getCurrentChar(vocabularyWord); as char) {
          <ng-container *ngTemplateOutlet="vocabulary_word_separator_template;context:{
                        char:char}"></ng-container>
          }
        <ng-container *ngTemplateOutlet="vocabulary_word_template;context:{
                      vocabularyWord: vocabularyWord}"></ng-container>
        }
      </div>
    }
  }
</ng-template>

<!-- Content -->
<div class="vocabulary mdsf-text scrollable editor-input">
  <section>
    <h1 translate="vocabulary_anatomy"></h1>
    <medsurf-text-format [text]="vocabulary.body"></medsurf-text-format>
    <div class="vocabulary-filter">
      <input class="vocabulary-filter-input"
        (keyup)="setFilter(vocabularyFilter.value)"
        placeholder="{{ 'search_after' | translate }}" #vocabularyFilter/>
    </div>
    <div>
      <input class="vocabulary-filter-placeholder"/>
    </div>
    <br>
      @if ((vocabularyViewerFacade.vocabularyGroupByIds$(vocabulary.vocabularyGroups) | async | sortBy_shared:'asc':'order'); as vocabularyGroups) {
        @for (vocabularyGroup of vocabularyGroups; track vocabularyGroup) {
          @if ((vocabularyViewerFacade.vocabularyWordByIds$(vocabularyGroup.vocabularyWords) | async | sortBy_shared:'asc':'key'); as vocabularyWords) {
          <ng-container *ngTemplateOutlet="vocabulary_group_template;context:{
                        vocabularyGroup: vocabularyGroup,
                        vocabularyWords: filterVocabularyWords(vocabularyWords),
                        showCurrentChar: vocabularyWords.length > 100}"></ng-container>
        
}
      
}
    
}
  </section>
</div>
